import { render, staticRenderFns } from "./CmgPasswordResetRequestPage.vue?vue&type=template&id=26c2b705&scoped=true&lang=pug&"
import script from "./cmg-password-reset-request-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-password-reset-request-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPasswordResetRequestPage.vue?vue&type=style&index=0&id=26c2b705&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c2b705",
  null
  
)

export default component.exports